import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Timer",
  "use": "Timer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Timer\"><path d=\"M15 1a1 1 0 110 2h-2v1.055a8.957 8.957 0 014.618 1.913l.675-.675a1 1 0 111.414 1.414l-.675.675A9 9 0 113 13a9 9 0 018-8.945V3H9a1 1 0 010-2h6zm-3 5a7 7 0 100 14 7 7 0 000-14zm0 3a1 1 0 011 1v2.586l1.707 1.707a1 1 0 01-1.414 1.414l-2-2A1 1 0 0111 13v-3a1 1 0 011-1z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol